import React, { cloneElement, ReactElement } from 'react';
import { Skeleton } from '../feedback/Skeleton';
import { Flex } from '../layout/Flex';

const StatItemSkeleton = () => (
    <Flex width="calc(100% / 3)" spacing={0.5} pb={2}>
        <Skeleton width="80px" variant="text" height={14} />
        <Skeleton width="80px" variant="text" height={24} />
    </Flex>
);

interface StatSectionSkeletonProps {
    statsSlot: ReactElement;
}

const StatSectionSkeleton = (props: StatSectionSkeletonProps) => {
    const { statsSlot } = props;

    return (
        <Flex
            background="var(--background-primary)"
            width="100%"
            pt={2}
            px={2}
            borderRadius={2}
            spacing={1.5}
        >
            <Skeleton width="30%" variant="text" height={24} />
            <Flex width="100%" direction="row" flexWrap="wrap">
                {cloneElement(statsSlot)}
            </Flex>
        </Flex>
    );
};

export const PostStatisticSkeleton = () => (
    <Flex width="100$" spacing={2} py={2}>
        <StatSectionSkeleton
            statsSlot={
                <>
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                </>
            }
        />
        <StatSectionSkeleton
            statsSlot={
                <>
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                </>
            }
        />
        <StatSectionSkeleton
            statsSlot={
                <>
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                </>
            }
        />
        <StatSectionSkeleton
            statsSlot={
                <>
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                </>
            }
        />
        <StatSectionSkeleton
            statsSlot={
                <>
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                    <StatItemSkeleton />
                </>
            }
        />
    </Flex>
);
